export var CalloutType;
(function (CalloutType) {
    CalloutType["success"] = "success";
    CalloutType["info"] = "info";
    CalloutType["warning"] = "warning";
    CalloutType["error"] = "error";
    CalloutType["note"] = "note";
    CalloutType["decision"] = "decision";
})(CalloutType || (CalloutType = {}));
